import values from 'lodash/values';

export default (headers) => values(headers).every((header) => !header.collapsed);
